import { listOfSubscriptions } from "../../../../common/envConfig";
import SelectMulti from "../../../../components/shared/Select/SelectMulti";

const subscriptionOptions = Object.entries(listOfSubscriptions || {}).map(
  ([key, value]) => ({
    text: key,
    value,
  })
);

export function SubscriptionFilter({
  draftSubscriptions,
  setDraftSubscriptions,
}) {
  return (
    <SelectMulti
      header="Subscriptions"
      onChange={(val) =>
        setDraftSubscriptions(
          Array.isArray(draftSubscriptions) && draftSubscriptions.includes(val)
            ? draftSubscriptions.filter((v) => v !== val)
            : [...draftSubscriptions, val]
        )
      }
      onClear={() => setDraftSubscriptions([])}
      options={subscriptionOptions}
      placeholder="Any subscription"
      values={draftSubscriptions}
      buttonProps={{
        rounded: "full",
        size: "md",
        className: "flex w-full flex-row items-center gap-2",
      }}
    />
  );
}
